<div class="sideBar">
    <img src="assets/img/cards/BACK.png" rel="" class="pack">
    <img cdkDropList src={{src}} rel="" class="discard">
</div>